export default __webpack_public_path__ + "037ff61091e5d735d33fe8ff1787744d.svg";